const semanticTokens = {
  colors: {
    // --- Background Tokens ---
    bg: {
      default: 'white',
      _dark: 'black',
    },
    'bg.subtle': {
      default: 'gray.50',
      _dark: 'gray.950',
    },
    'bg.muted': {
      default: 'gray.100',
      _dark: 'gray.900',
    },
    'bg.emphasized': {
      default: 'gray.200',
      _dark: 'gray.800',
    },
    'bg.inverted': {
      default: 'black',
      _dark: 'white',
    },
    'bg.panel': {
      default: 'white',
      _dark: 'gray.950',
    },
    'bg.error': {
      default: 'red.50',
      _dark: 'red.950',
    },
    'bg.warning': {
      default: 'orange.50',
      _dark: 'orange.950',
    },
    'bg.success': {
      default: 'green.50',
      _dark: 'green.950',
    },
    'bg.info': {
      default: 'blue.50',
      _dark: 'blue.950',
    },

    // --- Foreground Tokens ---
    fg: {
      default: 'black',
      _dark: 'gray.50',
    },
    'fg.muted': {
      default: 'gray.700',
      _dark: 'gray.400',
    },
    'fg.subtle': {
      default: 'gray.400',
      _dark: 'gray.500',
    },
    'fg.inverted': {
      default: 'gray.50',
      _dark: 'black',
    },
    'fg.error': {
      default: 'red.500',
      _dark: 'red.400',
    },
    'fg.warning': {
      default: 'orange.600',
      _dark: 'orange.300',
    },
    'fg.success': {
      default: 'green.600',
      _dark: 'green.300',
    },
    'fg.info': {
      default: 'blue.600',
      _dark: 'blue.300',
    },

    // --- Border Tokens ---
    border: {
      default: 'gray.200',
      _dark: 'gray.800',
    },
    'border.muted': {
      default: 'gray.100',
      _dark: 'gray.900',
    },
    'border.subtle': {
      default: 'gray.50',
      _dark: 'gray.950',
    },
    'border.emphasized': {
      default: 'gray.300',
      _dark: 'gray.700',
    },
    'border.inverted': {
      default: 'gray.800',
      _dark: 'gray.200',
    },
    'border.error': {
      default: 'red.500',
      _dark: 'red.400',
    },
    'border.warning': {
      default: 'orange.500',
      _dark: 'orange.400',
    },
    'border.success': {
      default: 'green.500',
      _dark: 'green.400',
    },
    'border.info': {
      default: 'blue.500',
      _dark: 'blue.400',
    },

    // --- Gray Palette ---
    'gray.contrast': {
      default: 'white',
      _dark: 'black',
    },
    'gray.fg': {
      default: 'gray.800',
      _dark: 'gray.200',
    },
    'gray.subtle': {
      default: 'gray.100',
      _dark: 'gray.900',
    },
    'gray.muted': {
      default: 'gray.200',
      _dark: 'gray.800',
    },
    'gray.emphasized': {
      default: 'gray.300',
      _dark: 'gray.700',
    },
    'gray.solid': {
      default: 'gray.900',
      _dark: 'white',
    },
    'gray.focusRing': {
      default: 'gray.400',
      _dark: 'gray.400',
    },
    'gray.border': {
      default: 'gray.200',
      _dark: 'gray.800',
    },

    // --- Red Palette ---
    'red.contrast': {
      default: 'white',
      _dark: 'white',
    },
    'red.fg': {
      default: 'red.700',
      _dark: 'red.300',
    },
    'red.subtle': {
      default: 'red.100',
      _dark: 'red.900',
    },
    'red.muted': {
      default: 'red.200',
      _dark: 'red.800',
    },
    'red.emphasized': {
      default: 'red.300',
      _dark: 'red.700',
    },
    'red.solid': {
      default: 'red.600',
      _dark: 'red.600',
    },
    'red.focusRing': {
      default: 'red.500',
      _dark: 'red.500',
    },
    'red.border': {
      default: 'red.500',
      _dark: 'red.400',
    },

    // --- Orange Palette ---
    'orange.contrast': {
      default: 'white',
      _dark: 'black',
    },
    'orange.fg': {
      default: 'orange.700',
      _dark: 'orange.300',
    },
    'orange.subtle': {
      default: 'orange.100',
      _dark: 'orange.900',
    },
    'orange.muted': {
      default: 'orange.200',
      _dark: 'orange.800',
    },
    'orange.emphasized': {
      default: 'orange.300',
      _dark: 'orange.700',
    },
    'orange.solid': {
      default: 'orange.600',
      _dark: 'orange.500',
    },
    'orange.focusRing': {
      default: 'orange.500',
      _dark: 'orange.500',
    },
    'orange.border': {
      default: 'orange.500',
      _dark: 'orange.400',
    },

    // --- Green Palette ---
    'green.contrast': {
      default: 'white',
      _dark: 'white',
    },
    'green.fg': {
      default: 'green.700',
      _dark: 'green.300',
    },
    'green.subtle': {
      default: 'green.100',
      _dark: 'green.900',
    },
    'green.muted': {
      default: 'green.200',
      _dark: 'green.800',
    },
    'green.emphasized': {
      default: 'green.300',
      _dark: 'green.700',
    },
    'green.solid': {
      default: 'green.600',
      _dark: 'green.600',
    },
    'green.focusRing': {
      default: 'green.500',
      _dark: 'green.500',
    },
    'green.border': {
      default: 'green.500',
      _dark: 'green.400',
    },

    // --- Blue Palette ---
    'blue.contrast': {
      default: 'white',
      _dark: 'white',
    },
    'blue.fg': {
      default: 'blue.700',
      _dark: 'blue.300',
    },
    'blue.subtle': {
      default: 'blue.100',
      _dark: 'blue.900',
    },
    'blue.muted': {
      default: 'blue.200',
      _dark: 'blue.800',
    },
    'blue.emphasized': {
      default: 'blue.300',
      _dark: 'blue.700',
    },
    'blue.solid': {
      default: 'blue.600',
      _dark: 'blue.600',
    },
    'blue.focusRing': {
      default: 'blue.500',
      _dark: 'blue.500',
    },
    'blue.border': {
      default: 'blue.500',
      _dark: 'blue.400',
    },

    // --- Yellow Palette ---
    'yellow.contrast': {
      default: 'black',
      _dark: 'black',
    },
    'yellow.fg': {
      default: 'yellow.800',
      _dark: 'yellow.300',
    },
    'yellow.subtle': {
      default: 'yellow.100',
      _dark: 'yellow.900',
    },
    'yellow.muted': {
      default: 'yellow.200',
      _dark: 'yellow.800',
    },
    'yellow.emphasized': {
      default: 'yellow.300',
      _dark: 'yellow.700',
    },
    'yellow.solid': {
      default: 'yellow.300',
      _dark: 'yellow.300',
    },
    'yellow.focusRing': {
      default: 'yellow.500',
      _dark: 'yellow.500',
    },
    'yellow.border': {
      default: 'yellow.500',
      _dark: 'yellow.500',
    },

    // --- Teal Palette ---
    'teal.contrast': {
      default: 'white',
      _dark: 'white',
    },
    'teal.fg': {
      default: 'teal.700',
      _dark: 'teal.300',
    },
    'teal.subtle': {
      default: 'teal.100',
      _dark: 'teal.900',
    },
    'teal.muted': {
      default: 'teal.200',
      _dark: 'teal.800',
    },
    'teal.emphasized': {
      default: 'teal.300',
      _dark: 'teal.700',
    },
    'teal.solid': {
      default: 'teal.600',
      _dark: 'teal.600',
    },
    'teal.focusRing': {
      default: 'teal.500',
      _dark: 'teal.500',
    },
    'teal.border': {
      default: 'teal.500',
      _dark: 'teal.400',
    },

    // --- Purple Palette ---
    'purple.contrast': {
      default: 'white',
      _dark: 'white',
    },
    'purple.fg': {
      default: 'purple.800',
      _dark: 'purple.200',
    },
    'purple.subtle': {
      default: 'purple.50',
      _dark: 'purple.900',
    },
    'purple.muted': {
      default: 'purple.300',
      _dark: 'purple.700',
    },
    'purple.emphasized': {
      default: 'purple.400',
      _dark: 'purple.600',
    },
    'purple.solid': {
      default: 'purple.600',
      _dark: 'purple.500',
    },
    'purple.focusRing': {
      default: 'purple.500',
      _dark: 'purple.500',
    },
    'purple.border': {
      default: 'purple.600',
      _dark: 'purple.300',
    },

    // --- Pink Palette ---
    'pink.contrast': {
      default: 'white',
      _dark: 'white',
    },
    'pink.fg': {
      default: 'pink.700',
      _dark: 'pink.300',
    },
    'pink.subtle': {
      default: 'pink.100',
      _dark: 'pink.900',
    },
    'pink.muted': {
      default: 'pink.200',
      _dark: 'pink.800',
    },
    'pink.emphasized': {
      default: 'pink.300',
      _dark: 'pink.700',
    },
    'pink.solid': {
      default: 'pink.600',
      _dark: 'pink.600',
    },
    'pink.focusRing': {
      default: 'pink.500',
      _dark: 'pink.500',
    },
    'pink.border': {
      default: 'pink.500',
      _dark: 'pink.400',
    },

    // --- Cyan Palette ---
    'cyan.contrast': {
      default: 'white',
      _dark: 'white',
    },
    'cyan.fg': {
      default: 'cyan.700',
      _dark: 'cyan.300',
    },
    'cyan.subtle': {
      default: 'cyan.100',
      _dark: 'cyan.900',
    },
    'cyan.muted': {
      default: 'cyan.200',
      _dark: 'cyan.800',
    },
    'cyan.emphasized': {
      default: 'cyan.300',
      _dark: 'cyan.700',
    },
    'cyan.solid': {
      default: 'cyan.600',
      _dark: 'cyan.600',
    },
    'cyan.focusRing': {
      default: 'cyan.500',
      _dark: 'cyan.500',
    },
    'cyan.border': {
      default: 'cyan.500',
      _dark: 'cyan.400',
    },

    // --- Primary Brand Palette ---
    'primary.solid': { default: 'teal.600', _dark: 'teal.500' },
    'primary.contrast': { default: 'white', _dark: 'gray.950' },
    'primary.fg': { default: 'teal.700', _dark: 'teal.300' },
    'primary.muted': { default: 'teal.100', _dark: 'teal.900' },
    'primary.subtle': { default: 'teal.50', _dark: 'teal.950' },
    'primary.emphasized': { default: 'teal.700', _dark: 'teal.400' },
    'primary.focusRing': { default: 'teal.600', _dark: 'teal.500' },
    'primary.border': { default: 'teal.600', _dark: 'teal.500' },

    // --- Secondary Brand Palette ---
    'secondary.solid': { default: 'purple.600', _dark: 'purple.500' },
    'secondary.contrast': { default: 'white', _dark: 'gray.950' },
    'secondary.fg': { default: 'purple.800', _dark: 'purple.200' },
    'secondary.muted': { default: 'purple.100', _dark: 'purple.900' },
    'secondary.subtle': { default: 'purple.50', _dark: 'purple.950' },
    'secondary.emphasized': { default: 'purple.800', _dark: 'purple.300' },
    'secondary.focusRing': { default: 'purple.700', _dark: 'purple.400' },
    'secondary.border': { default: 'purple.700', _dark: 'purple.400' },

    // --- Neutrals (Alias of gray) ---
    'neutrals.contrast': {
      default: 'white',
      _dark: 'black',
    },
    'neutrals.fg': {
      default: 'gray.800',
      _dark: 'gray.200',
    },
    'neutrals.subtle': {
      default: 'gray.100',
      _dark: 'gray.900',
    },
    'neutrals.muted': {
      default: 'gray.200',
      _dark: 'gray.800',
    },
    'neutrals.emphasized': {
      default: 'gray.300',
      _dark: 'gray.700',
    },
    'neutrals.solid': {
      default: 'gray.900',
      _dark: 'white',
    },
    'neutrals.focusRing': {
      default: 'gray.400',
      _dark: 'gray.400',
    },
    'neutrals.border': {
      default: 'gray.200',
      _dark: 'gray.800',
    },

    // --- Info (Alias of blue) ---
    'info.contrast': {
      default: 'white',
      _dark: 'white',
    },
    'info.fg': {
      default: 'blue.700',
      _dark: 'blue.300',
    },
    'info.subtle': {
      default: 'blue.100',
      _dark: 'blue.900',
    },
    'info.muted': {
      default: 'blue.200',
      _dark: 'blue.800',
    },
    'info.emphasized': {
      default: 'blue.300',
      _dark: 'blue.700',
    },
    'info.solid': {
      default: 'blue.600',
      _dark: 'blue.600',
    },
    'info.focusRing': {
      default: 'blue.500',
      _dark: 'blue.500',
    },
    'info.border': {
      default: 'blue.500',
      _dark: 'blue.400',
    },

    // --- Success (Alias of green) ---
    'success.contrast': {
      default: 'white',
      _dark: 'white',
    },
    'success.fg': {
      default: 'green.700',
      _dark: 'green.300',
    },
    'success.subtle': {
      default: 'green.100',
      _dark: 'green.900',
    },
    'success.muted': {
      default: 'green.200',
      _dark: 'green.800',
    },
    'success.emphasized': {
      default: 'green.300',
      _dark: 'green.700',
    },
    'success.solid': {
      default: 'green.600',
      _dark: 'green.600',
    },
    'success.focusRing': {
      default: 'green.500',
      _dark: 'green.500',
    },
    'success.border': {
      default: 'green.500',
      _dark: 'green.400',
    },

    // --- Warning (Alias of orange) ---
    'warning.contrast': {
      default: 'white',
      _dark: 'black',
    },
    'warning.fg': {
      default: 'orange.700',
      _dark: 'orange.300',
    },
    'warning.subtle': {
      default: 'orange.100',
      _dark: 'orange.900',
    },
    'warning.muted': {
      default: 'orange.200',
      _dark: 'orange.800',
    },
    'warning.emphasized': {
      default: 'orange.300',
      _dark: 'orange.700',
    },
    'warning.solid': {
      default: 'orange.600',
      _dark: 'orange.500',
    },
    'warning.focusRing': {
      default: 'orange.500',
      _dark: 'orange.500',
    },
    'warning.border': {
      default: 'orange.500',
      _dark: 'orange.400',
    },

    // --- Error (Alias of red) ---
    'error.contrast': {
      default: 'white',
      _dark: 'white',
    },
    'error.fg': {
      default: 'red.700',
      _dark: 'red.300',
    },
    'error.subtle': {
      default: 'red.100',
      _dark: 'red.900',
    },
    'error.muted': {
      default: 'red.200',
      _dark: 'red.800',
    },
    'error.emphasized': {
      default: 'red.300',
      _dark: 'red.700',
    },
    'error.solid': {
      default: 'red.600',
      _dark: 'red.600',
    },
    'error.focusRing': {
      default: 'red.500',
      _dark: 'red.500',
    },
    'error.border': {
      default: 'red.500',
      _dark: 'red.400',
    },
  },
}

export default semanticTokens
